import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getOriginalStatus} from "../../store/utils/get_original_status";
import {getSilentErrorResponse} from "../../store/utils/get_silent_error_response";
import {IPatchUserProfilePayload} from "../types/IPatchUserProfilePayload";
import {IUserProfile} from "../types/IUserProfile";

const patchUserProfileQuery = (body: IPatchUserProfilePayload) => ({
    url: apiUserLink.user.info,
    method: "PATCH",
    body
});

// a 5xx is the only failure the form cannot explain - reported under the name of the form that saves this way, the reservation name step
const transformSilentPatchUserProfileError = (response: FetchBaseQueryError) => {
    const status = getOriginalStatus(response) ?? response.status;
    const isServerError = typeof status === "number" && status >= 500;

    return getSilentErrorResponse(
        response,
        isServerError
            ? {
                  error: {name: "ReservationProfileNameError", message: String(status), groupingHash: "reservation_profile_name_failure"},
                  context: "reservation profile name save failure",
                  metadata: {status: response.status}
              }
            : null
    );
};

export const patchUserProfileApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        patchUserProfile: builder.mutation<IUserProfile, IPatchUserProfilePayload>({
            query: patchUserProfileQuery,
            invalidatesTags: ["UserProfile"]
        }),
        // For a form that shows a failed save itself, e.g. inside a modal - the RTK middleware never replaces the page with the error view
        patchUserProfileSilently: builder.mutation<IUserProfile, IPatchUserProfilePayload>({
            query: patchUserProfileQuery,
            transformErrorResponse: transformSilentPatchUserProfileError,
            invalidatesTags: ["UserProfile"]
        })
    }),
    overrideExisting: false
});

export const {usePatchUserProfileMutation, usePatchUserProfileSilentlyMutation} = patchUserProfileApi;
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

import {apiUserLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getOriginalStatus} from "../../store/utils/get_original_status";
import {getSilentErrorResponse} from "../../store/utils/get_silent_error_response";
import {IPatchUserProfilePayload} from "../types/IPatchUserProfilePayload";
import {IUserProfile} from "../types/IUserProfile";

const patchUserProfileQuery = (body: IPatchUserProfilePayload) => ({
    url: apiUserLink.user.info,
    method: "PATCH",
    body
});

// a 5xx is the only failure the form cannot explain - reported under the name of the form that saves this way, the reservation name step
const transformSilentPatchUserProfileError = (response: FetchBaseQueryError) => {
    const status = getOriginalStatus(response) ?? response.status;
    const isServerError = typeof status === "number" && status >= 500;

    return getSilentErrorResponse(
        response,
        isServerError
            ? {
                  error: {name: "ReservationProfileNameError", message: String(status), groupingHash: "reservation_profile_name_failure"},
                  context: "reservation profile name save failure",
                  metadata: {status: response.status}
              }
            : null
    );
};

export const patchUserProfileApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        patchUserProfile: builder.mutation<IUserProfile, IPatchUserProfilePayload>({
            query: patchUserProfileQuery,
            invalidatesTags: ["UserProfile"]
        }),
        // For a form that shows a failed save itself, e.g. inside a modal - the RTK middleware never replaces the page with the error view
        patchUserProfileSilently: builder.mutation<IUserProfile, IPatchUserProfilePayload>({
            query: patchUserProfileQuery,
            transformErrorResponse: transformSilentPatchUserProfileError,
            invalidatesTags: ["UserProfile"]
        })
    }),
    overrideExisting: false
});

export const {usePatchUserProfileMutation, usePatchUserProfileSilentlyMutation} = patchUserProfileApi;
